import { Col, Row } from "antd";
import Header from "./Header";
import Content from "./Content";
import MazakaCard from "apps/Common/MazakaCart";
import { FC } from "react";


const ViewInvoiceDetails:FC<{selectedRecord:null |any}> = ({selectedRecord}) => {
    return ( 
        <>
        <MazakaCard xs={24} >
            <Row gutter={[0,30]} >
            <Col xs={24} className="!flex justify-end"  >
        
        </Col>
                <Col xs={24} >
                    <Header selectedRecord={selectedRecord}/>
                </Col>
                <Col xs={24} className=""  >
                    <Content selectedRecord={selectedRecord}/>
                </Col>
            </Row>
        </MazakaCard>
        </>
     );
}
 
export default ViewInvoiceDetails;